import http from '../../../service/axios';
import { ISaveCard } from '../types/CardList';
import { ICreateCard } from '../types/Create';

export const userCardAPI = {
  getAll: async () => await http.get('/card/list'),
  create: async (body: ICreateCard) => await http.post('/card/add', body),
  delete: async (id: number) => await http.post(`/card/delete`, { id }),
  confirm: async (body: ISaveCard) => await http.post(`/card/confirm`, body),
};
